import './__util__';
import { mark } from './mark';
export function markCircle() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return mark.apply(void 0, [{
    "type": "circle"
  }].concat(args));
}